module.exports = __webpack_public_path__ + "static/img/on12.592e78fe.png";